import React, { useState,useEffect,useRef } from 'react';
import { Row, Col } from "react-bootstrap";
import * as Mui  from '@mui/material';
import { useCookies } from 'react-cookie';
import Datex from '@drumtj/datex';
import Home from './Home'
import Transport from './Transport';
import '../lib/bootstrap.min.css'
import './Main.css';
import Fnb from './Fnb';
import Clock from './ClockWidget';
import RoomService from './RoomService';
import Property from './Property';
import Welcome from './Welcome';
import License from './License';
import dba from '../lib/db.json';
import Promo from './Promo';
import { useParams } from "react-router-dom";
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: 10,
      top: 8,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));

const MainPage = (props) => {

    const path  = useParams()
    var _valid = 100;
    const db = JSON.parse(JSON.stringify(dba))

    const [cookie,setCookie, removeCookie] = useCookies(['netVis_']);


    const[openAlert,setOpenAlert] = useState(false)
    const [profileHome,setProfileHome] = useState()
    const [profileProperty,setProfileProperty] = useState()
    const [profileOverview,setProfileOverview] = useState()
    const [profileClock,setProfileClock] = useState()
    const [profileTransport,setProfileTransport] = useState()
    const [profileFnb,setProfileFnb] = useState()
    const [profilePromo,setProfilePromo] = useState()

    const [roomActive, setRoomActive] = useState()
    const [roomServices,setRoomServices] = useState()
    const [roomUser,setRoomUser] = useState()
    const [roomServiceNotif,setRoomServiceNotif] = useState(null)
    const [lastUpdate,setLastUpdate] = useState(0)
    const [readNotif,setReadNotif] = useState(Number(cookie.roomServiceCheck))

    const [hWindow, setHWindow] = useState(0);
    const [hHeader, setHHeader] = useState(110);
    const [hContent, setHContent] = useState(352);
    const [hFooter, setHFooter] = useState(80);

    const [loading,setLoading] = useState(false);
    const [loadingGetData,setLoadingGetData] = useState(true);

    const [isPage, setIsPage] = useState('property');
    const [background,setBackground] = useState()
    const [clickCount,setClickCount] = useState(0)
    const [openModal,setOpenModal] = useState(false)
    const [weatherLoading, setWeatherLoading] = useState(false);
    const ref = useRef(null);
    const worldClockRef = useRef()
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)

    const [deviceId,setDeviceId] = useState()
    const [logId,setLogId] = useState(0)
    
    
    const openPage = (page) =>{
        switch(isPage) {
            case 'home':
                if(isPage==='home' && page === 'home'){
                    setClickCount(clickCount+1)
                    if(clickCount>19){
                        setOpenModal(true)
                        /*var return_value=prompt("Password:");
                        if(return_value==="4554"){
                            page = 'setting'
                            setClickCount(0)
                        }*/
                    }
                }
              break;
            case 'property':
                if(isPage==='property' && page === 'property'){
                    setClickCount(clickCount+1)
                    if(clickCount>19){
                        setOpenModal(true)
                        /*var return_value=prompt("Password:");
                        if(return_value==="4554"){
                            page = 'setting'
                            setClickCount(0)
                        }*/
                    }
                }
              break;
            case 'worldclock':
                setClickCount(0)
                worldClockRef.current.exitPage()
              break;
            case 'roomservice':
                const unixTimestamp = Math.floor(new Date().getTime() / 1000);
                setCookie('roomServiceCheck', unixTimestamp);
                getData()
              break;
            default:
                setClickCount(0)
          }
        setIsPage(page)
    }
    const getData = () => {
        setLoading(true)
          
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("path", path.id)

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
            
        fetch(props.config.hostApi + "app/profile/device-path", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if(result.success){
                if(result.data.room.checkin == 0 && isPage === 'roomservice'){
                    openPage('home')
                }
                setDeviceId(result.data.id)
                setProfileHome(result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail)

                setBackground(result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'background')[0].value)
                var weatherLat = result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_lat')[0].value
                var weatherLon = result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_lon')[0].value
                var weatherKey = result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_key')[0].value
                var weatherUnit=result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'home_page')[0].object_detail.filter((_profile)=> _profile.object === 'weather_unit')[0].value
                getWeather(weatherLat,weatherLon,weatherKey,weatherUnit)

                setProfileProperty(result.data.device_profile.object_profile)

                var mappingTimezone = []
                for(var i =0; i < 5; i++){ 
                    mappingTimezone[i] = {
                        id: "timezone_"+(i+1),
                        timezone: result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'clock_timezone')[0].object_detail.filter((_profile)=> _profile.object === 'timezone_'+(i+1))[0].value,
                        title: result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'clock_timezone')[0].object_detail.filter((_profile)=> _profile.object === 'title_'+(i+1))[0].value
                    }
                }
                setProfileClock(mappingTimezone)

                setProfileTransport(result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'transport')[0].object_detail)

                setProfileFnb(result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'restaurant')[0].object_detail)

                setProfilePromo(result.data.device_profile.object_profile.filter((object_profile)=> object_profile.object_name === 'promo')[0].object_detail)
                //console.log('result.data.room')
                //console.log(result.data.room)
                setRoomActive(result.data.room)
                //getRoomServices(result.data.room.reservation_active[0].reservation_key)
                setRoomUser(result.data.user)
                setLoading(false)
                setLoadingGetData(false)
            }else{
                setLoading(false);
            
            }
        })
        .catch((error) => {
            setLoading(false);
            
        })
            
        setLoading(false)
    };

    const setLog = (device_id, app_name, app_alias) => {
        setLoading(true)
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("device_id",device_id)
        formdata.append("app_name",app_name)
        formdata.append("app_alias",app_alias)

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
            
        fetch(props.config.hostApi + "app/log-app/create", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if(result.success){
                console.log(result)
                setLogId(result.data.id)
            }else{
                setLoading(false);
            }
        })
        .catch((error) => {
            setLoading(false);
        })
            
        setLoading(false)
    };

    const getRoomServices = (reservation_key) => {
        setLoading(true)
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");

        const formdata = new URLSearchParams();
        formdata.append("reservation_key",reservation_key)

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
            
        fetch(props.config.hostApi + "mobile/room-service", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if(result.success){
                setRoomServices(result.data.room_services)
                setLoading(false)
                //Set Badge
                var newNotif = result.data.room_services.filter((object)=>  Math.floor(new Date(object.updated_at).getTime() / 1000) > readNotif).length

                setLastUpdate(Math.floor(new Date(result.data.room_services[0].updated_at).getTime() / 1000))
                if(newNotif>0){
                    setRoomServiceNotif(' ')
                }else{
                    setRoomServiceNotif(null)
                }

            }else{
                setLoading(false);
            }
        })
        .catch((error) => {
            setLoading(false);
        })
            
        setLoading(false)
    };

    const getWeather = (lat,lon,key,unit) =>{
        setWeatherLoading(true)
        const myHeaders = new Headers();
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch('https://api.openweathermap.org/data/2.5/weather?lat='+lat+'&lon='+lon+'&appid='+key+'&units='+unit, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                //console.log(result)
                document.getElementById("weather_city").innerHTML = result.name+`<br />`+ new Datex(Date.now()).format("DDD, DD MMM YYYY")
                document.getElementById("weather_time").innerHTML = new Datex(Date.now()).format("hh:mm")
                document.getElementById("weather_icon").innerHTML = `
                <img src='https://rodrigokamada.github.io/openweathermap/images/`+result.weather[0].icon + `_t@2x.png' height='80' alt='weather' />`
                document.getElementById("weather_temp").innerHTML = parseInt(result.main.temp)+`<sup> o</sup>`
                
                setWeatherLoading(false)
            })
            .then((error)=>{
                setWeatherLoading(false)
            })
        
    }

   /* const readTheNotif = () =>{
        if(readNotif == 1 ){
            setRoomServiceNotif(null)
        }
    }*/
    
    useEffect(() => {
        getData()
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
        setHWindow(ref.current.clientHeight);

        /*
        const timerNotif = window.setInterval(() => { 
            console.log(readNotif)
            console.log(lastUpdate +'>'+readNotif)
        }, 1000);
        */

        const timer = window.setInterval(() => { 
            //console.log('Interval')
            getData()
        }, 15000);
        return () => {
            //window.clearInterval(timerNotif)
            window.clearInterval(timer)
        }
    },[roomServiceNotif,lastUpdate, readNotif]);


  return (
    <>
        <style>{`
            .tv{
                background:linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url('`+ background +`') no-repeat;
                background-size: cover;
            }
            .header{
                height: `+hHeader+`px;
            }
            .content{
                height: `+hContent+`px;
            }
            .footer{
                height: `+hFooter+`px;
            }
            #modal-modal-description .btnHome{
                min-width:170px;
                margin: 0 5px 10px 5px
            }
        `}</style>
        <Mui.Modal
            open={openModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Mui.Box style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                background: '#ffffff',
                color: '#000000',
                border: '0px solid #000',
                boxShadow: 24,
                padding: '5px 15px',
            }}>
            <Mui.Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <button className="btnHome"  onClick={()=>{window.ReactNativeWebView.postMessage("openSetting")}}>
                        Setting
                    </button>
                    <button className="btnHome" onClick={()=>{window.ReactNativeWebView.postMessage("com.cybercat.adbappcontrol.tv")}}>
                        Open Console
                    </button>
                    <button className="btnHome"  onClick={()=>{window.ReactNativeWebView.postMessage("openLauncher")}}>
                        Activate TV
                    </button>
                    <button className="btnHome"  onClick={()=>{setOpenModal(false); setClickCount(0)}}>
                        Close 
                    </button>
            </Mui.Typography>
            </Mui.Box>
        </Mui.Modal>
        <Mui.Backdrop
          sx={(theme) => ({ backgroundColor:'red', color: '#fff', zIndex: 999 })}
          open={loading}
        >
            <Mui.CircularProgress color="inherit" /> 
            <Mui.Typography style={{marginLeft: '30px'}}>Please wait..</Mui.Typography>
        </Mui.Backdrop>
        <div className='tv' id='tv' ref={ref}>
            <div id='sn' style={{display:'none'}}></div>
            <Row className='header' id='header'>
                <Col md={7}>
                    <div className='header-left'>      
                        <div className="logo"><img src={db.profile_device[0].content.home_page.logo} alt='logo' /></div>
                    </div>
                </Col>
                <Col md={5}>
                    <div className='header-right'>
                        <div className='weather' id='weather'>
                            <div id='weather_city'></div>
                            <div id='weather_time'></div>
                            <div id='weather_icon'></div>
                            <div id='weather_temp'></div>
                        </div>
                    </div>
                </Col>
            </Row>
            { loadingGetData === false && 
                <div className='content'>
                {isPage === 'license' && (<License height={hContent} valid={_valid} goToHome={()=>{openPage('welcome')}} />)}
                {isPage === 'welcome' && (<Welcome height={hContent} db={db} goToHome={()=>{openPage('home')}} />)}
                
                {isPage === 'property' && (
                    <Property height={hContent} 
                        profile={profileProperty} 
                        reservation = {roomActive}
                        page={isPage}  
                    />
                )}
                {isPage === 'home' && (
                    <Home height={hContent} 
                        profile={profileHome}  
                        reservation = {roomActive}
                        propertyInfo={()=>{openPage('property')}} 
                    />
                )}
                {isPage === 'roomservice' && (
                    <RoomService 
                        height={hContent}
                        config = {props.config}
                        roomServices = {roomServices}
                        reservation = {roomActive}
                        user = {roomUser}
                        refresh = {getData}
                    />)}

                {isPage === 'worldclock' && (
                    <Clock ref={worldClockRef} 
                        height={hContent} 
                        profile={profileClock}
                        page={isPage} 
                    />
                )}

                {isPage === 'transport' && (
                    <Transport 
                            height={hContent} 
                            profile={profileTransport}
                            page={isPage}
                    />)}   

                {isPage === 'fnb' && (
                    <Fnb 
                            height={hContent} 
                            profile={profileFnb}
                            page={isPage}
                    />)}   

                

                {isPage === 'promo' && (
                    <Promo 
                        height={hContent} 
                        profile={profilePromo} 
                        //guide={db.profile_device[0].content.promo_guide} 
                    />)}

                {isPage === 'promo1' && (
                    <Promo 
                        height={hContent} 
                        content={db.profile_device[0].content.promo} 
                        guide={db.profile_device[0].content.promo_guide} 
                    />)}
                </div> 
            }
            <Row className='footer' id='footer'>
               <Col md={12}>
                    <button className='bmenu' tabIndex={1} 
                        onClick={()=>{ 
                            openPage('property')

                            setLog(deviceId, 'Home', 'home')
                        }}
                    >
                        <img src='/icons/home.png' alt='Property' height={27} />
                    </button>
                    <button className='bmenu' tabIndex={1} onClick={()=>{
                            window.ReactNativeWebView.postMessage("com.nathnetwork.gachortv")
                            setLog(deviceId, 'TV Channel', 'tv_channel')
                        }}>
                        <img src='/icons/tv.png' alt='Tv Channel' height={28} />
                    </button>
                    <button className='bmenu' tabIndex={2} onClick={()=>{
                        window.ReactNativeWebView.postMessage("com.google.android.youtube.tv")
                        setLog(deviceId, 'Youtube', 'youtube')
                        }}>
                        <img src='/icons/youtube.png' alt='Youtube' height={24} />
                    </button>
                    <button className='bmenu' tabIndex={3} onClick={()=>{
                        window.ReactNativeWebView.postMessage("com.netflix.ninja")
                        setLog(deviceId, 'Netflix', 'netflix')
                        }}>
                        <img src='/icons/netflix.png' alt='Netflix' height={17} />
                    </button>
                    <button className='bmenu' tabIndex={4} onClick={()=>{
                        window.ReactNativeWebView.postMessage("com.amazon.amazonvideo.livingroom")
                        //window.ReactNativeWebView.postMessage("com.amazon.avod.thirdpartyclient")
                        setLog(deviceId, 'Prime Video', 'prime_video')
                        }}>
                        <img src='/icons/prime-video.png' alt='Prime Video' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={5} onClick={()=>{
                        window.ReactNativeWebView.postMessage("com.vidio.android.tv")
                        setLog(deviceId, 'Vidio', 'vidio')
                    }}>
                        <img src='/icons/vidio.png' alt='Vidio' height={22} />
                    </button>
                    <button className='bmenu' tabIndex={7} onClick={()=>{
                        window.ReactNativeWebView.postMessage("in.startv.hotstar.dplus.tv")
                        setLog(deviceId, 'Disney +', 'disney+')
                    }}>
                        <img src='/icons/disney.png' alt='Disney +' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={7} onClick={()=>{ 
                        openPage('worldclock')
                        setLog(deviceId, 'World Clock', 'worldclock')
                        }}>
                        <img src='/icons/worldclock.png' alt='World Clock' height={32} />
                    </button>
                    {/* <button className='bmenu' tabIndex={8} onClick={()=>{ openPage('flight')}}>
                        <img src='/icons/flight.png' alt='Flight Schedule' height={32} />
                    </button> */}
                    <button className='bmenu' tabIndex={9} onClick={()=>{ 
                        openPage('transport')
                        setLog(deviceId, 'Transport', 'transport')
                        }}>
                        <img src='/icons/transport.png' alt='Transport' height={26} />
                    </button>
                    <button className='bmenu' tabIndex={10} onClick={()=>{ 
                        openPage('fnb')
                        setLog(deviceId, 'F&B', 'fnb')
                        }}>
                        <img src='/icons/fnb.png' alt='Food and Beverage' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={11} onClick={()=>{ 
                        openPage('promo')
                        setLog(deviceId, 'Promo', 'promo')
                        }}>
                        <img src='/icons/discount.png' alt='Promo' height={32} />
                    </button>
                    {/*
                    <StyledBadge badgeContent={roomServiceNotif} color="warning"> 
                        <button className='bmenu' tabIndex={12} onClick={()=>{ 
                                if(roomActive.checkin==1){
                                    setReadNotif(Math.floor(new Date().getTime() / 1000))
                                    openPage('roomservice')
                                    setLog(deviceId, 'Room Service', 'roomservice')
                                }else{
                                    setOpenAlert(true)
                                }
                                
                            }}>
                            <img src='/icons/helpdesk.png' alt='Helpdesk' height={32} />
                        </button>
                    </StyledBadge>
                    <button className='bmenu' tabIndex={12} onClick={()=>{ openPage('wifi')}}>
                        <img src='icons/wifi.png' alt='Wifi' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={13} onClick={()=>{ openPage('wakeupcall')}}>
                        <img src='icons/wake-up.png' alt='Wakeup Call' height={32} />
                    </button>
                    <button className='bmenu' tabIndex={13} onClick={()=>{ openPage('settings')}}>
                        <img src='icons/settings.png' alt='Settings' height={27} />
                    </button>*/}
                    
                </Col>
            </Row>
            <Mui.Snackbar open={openAlert} autoHideDuration={6000} onClose={()=>{setOpenAlert(false)}}>
                <Mui.Alert
                onClose={()=>{setOpenAlert(false)}}
                severity="warning"
                variant="filled"
                sx={{ width: '100%' }}
                >
                No Reservation in this room !
                </Mui.Alert>
            </Mui.Snackbar>
        </div>
    </>
  );
};

export default MainPage;


